/**
 * @packageDocumentation
 * @module HackerAPI.Event.Attendee
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import { parseDate } from "../../utils/utils";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
/**
 * A container for data related to an `Event` that a `User` is attending.
 * Check out the `HackerAPI.User` class for modifying
 * @struct
 * @extends { HackerAPI.Base }
 */
var Attendee = /** @class */ (function (_super) {
    __extends(Attendee, _super);
    function Attendee(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, role = _b.role, user_id = _b.user_id, user_name = _b.user_name, name = _b.name, user_email = _b.user_email, email = _b.email, mentor_skills = _b.mentor_skills, mentorSkills = _b.mentorSkills, mentor_location = _b.mentor_location, eventId = _b.eventId, event_id = _b.event_id, eventSlug = _b.eventSlug, event_slug = _b.event_slug, mentorLocation = _b.mentorLocation, bio = _b.bio, avatar = _b.avatar, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt, badge_codes = _b.badge_codes, badgeCodes = _b.badgeCodes;
        var _this = _super.call(this, {
            id: Base.doNotSendHandler,
            name: Base.doNotSendHandler,
            email: Base.doNotSendHandler,
            eventSlug: Base.doNotSendHandler,
            eventId: Base.doNotSendHandler,
            mentorSkills: Base.doNotSendHandler,
            mentorLocation: Base.doNotSendHandler,
            bio: Base.doNotSendHandler,
            avatar: Base.doNotSendHandler,
            createdAt: Base.doNotSendHandler,
            updatedAt: Base.doNotSendHandler
        }) || this;
        /**
         * The attendee's ID for this event. Not to be confused with their user ID
         * @type { number }
         */
        _this.id = id;
        /**
         * The attendee's role at the event
         * @type { string }
         */
        _this.role = role;
        /**
         * The attendee's user ID. Use this to get more info about them.
         * @type { number }
         */
        _this.userId = user_id;
        /**
         * The attendee's name
         * @type { string }
         */
        _this.name = user_name || name;
        /**
         * The attendee's email
         * @type { string }
         */
        _this.email = user_email || email;
        /**
         * @type { number }
         */
        _this.eventId = event_id || eventId;
        /**
         * @type { string }
         */
        _this.eventSlug = eventSlug || event_slug;
        /**
         * @type { string[] }
         */
        _this.mentorSkills = mentor_skills || mentorSkills;
        /**
         * @type { string }
         */
        _this.mentorLocation = mentor_location || mentorLocation;
        /**
         * @type { string }
         */
        _this.bio = bio;
        /**
         * Link to their avatar
         * @type { string }
         */
        _this.avatar = avatar;
        /**
         * @type { string[] }
         */
        _this.badgeCodes = badge_codes || badgeCodes;
        /**
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Gets the list of attendees from HackerAPI for a given event
     * @param - The event to get the attendees list for
     * @param [token]
     * @returns
     */
    Attendee.fetchAll = function (_a, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/attendees",
            method: "GET",
            token: token
        }).then(function (data) {
            return data.map(function (datum) { return new Attendee(datum); });
        });
    };
    /**
     * Gets the list of attendees from HackerAPI for a given event
     * @param - The event to get the attendees list for
     * @param
     * @param [token]
     * @returns
     */
    Attendee.fetch = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/attendees/" + id,
            method: "GET",
            token: token
        }).then(function (data) { return new Attendee(data); });
    };
    /**
     * Adds an attendee to the event. Only their id and role are sent in the request. Check out
     * `HackerAPI.User` for how to modify the other values
     * @param event - The event to add the attendee to
     * @param event.slug
     * @param attendee - The attendee's info
     * @param attendee.userId
     * @param attendee.role
     * @param token
     * @returns - The attendee returned from the server
     */
    Attendee.create = function (_a, attendee, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "v2/events/" + slug + "/attendees",
            method: "POST",
            token: token,
            body: attendee.toHackerAPIFormat()
        }).then(function (data) {
            return new Attendee(data);
        });
    };
    /**
     * Removes an attendee from this event
     * @param event - The event to remove the attendee from
     * @param attendee - The attendee to delete
     * @param token
     * @returns If no error is thrown then successful delete
     */
    Attendee.removeAttendee = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/attendees/" + id,
            method: "DELETE",
            token: token
        });
    };
    return Attendee;
}(Base));
export default Attendee;
//# sourceMappingURL=attendee.js.map